module.exports = __webpack_public_path__ + "static/img/BANNER01_mobile.26494ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/BANNER01_mobile.png
// module id = aIgL
// module chunks = 0